import { APPSTATE_KEY } from './reducers';
import { List } from 'immutable';
import { LESSON } from 'phoenix2/state/session/session-types';
import { getSessionType } from 'phoenix2/state/session/selectors';
import { getFeatureFlag } from 'phoenix2/state/feature-flags/selectors';
import { FEATURE_FLAG_ASSET_SERVER_OVERRIDE } from 'phoenix2/state/feature-flags';

export const getAppState = state => state.get(APPSTATE_KEY);

export const isTaskLocked = (state, taskId) => {
    const appState = getAppState(state);
    const lockTasks = appState.get('lockTasks');
    if (!lockTasks) {
        return false;
    }
    const activeTasks = appState.get('activeTasks');
    return activeTasks && !activeTasks.has(taskId);
};

export const getHandsUp = state => getAppState(state).get('handsUp', false);

export const getLockState = state => getAppState(state).get('locked');

export const getFreeGames = state =>
    getSessionType(state) === LESSON ? List() : getAppState(state).get('freeGames');

export const getActivityRestoreInfo = state => getAppState(state).get('activityRestoreInfo');

export const getEtag = state => getAppState(state).get('etag');

export const getAssetsServer = state => {
    const assetServer = getAppState(state).get('assetsServer');

    // Allow the asset server to be replaced with one from launch darkly
    const override = getFeatureFlag(state, FEATURE_FLAG_ASSET_SERVER_OVERRIDE);
    const overrideValid = override && (typeof override === 'string' || override instanceof String);
    if (assetServer && overrideValid && override.startsWith('https://')) {
        return assetServer.set('assetServerURL', override);
    }
    return assetServer;
};

export const getKeyboardHandlerId = state => getAppState(state).get('keyboardHandlerId');

export const getDisableTablesGamesTimer = state =>
    getAppState(state).get('disableTablesGamesTimer', false);

/**
 * Get the current image zoom spec (if null, not zooming)
 * @param state
 */
export const getImageZoomSpec = state => getAppState(state).get('imageZoom');

export const isImageZoomShowing = state => !!getAppState(state).get('imageZoom');

export const getPopLastViewURL = state => getAppState(state).get('popLastViewURL');
